module.exports = __webpack_public_path__ + "static/media/glanum_markt.0fb7e756.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_markt.png
// module id = 719
// module chunks = 0